module.exports = __webpack_public_path__ + "static/header-icon-f723e2d222014a7b203d0bcfbf2c099f.png";